import { render, staticRenderFns } from "./typeIndex.vue?vue&type=template&id=41fa0ed5&scoped=true&"
import script from "./typeIndex.vue?vue&type=script&lang=js&"
export * from "./typeIndex.vue?vue&type=script&lang=js&"
import style0 from "./typeIndex.vue?vue&type=style&index=0&id=41fa0ed5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fa0ed5",
  null
  
)

export default component.exports